import InputSigarusText from '../InputSigarusText'
import InputSigarusPassword from '../InputSigarusPassword'
import InputSigarusTextarea from '../InputSigarusTextarea'
import InputSigarusFile from '../InputSigarusFile'
import InputSigarusFileDrag from '../InputSigarusFileDrag'
import InputSigarusLink from '../InputSigarusLink'
import InputSigarusTimePicker from '../InputSigarusTimePicker'
import InputSigarusDatePicker from '../InputSigarusDatePicker'
import InputSigarusDateTimePicker from '../InputSigarusDateTimePicker'
import InputSigarusCheckbox from '../InputSigarusCheckbox'
import InputSigarusEditor from '../InputSigarusEditor'
import InputSigarusSwitch from '../InputSigarusSwitch'
import InputSigarusHidden from '../InputSigarusHidden'
import InputSigarusCheckboxList from '../InputSigarusCheckboxList'
import numberVariations from './numberVariations'
import selectVariations from './selectVariations'
import inputExtend from './inputExtend'


/*
TEST HOOKS
const textprueba = inputExtend(InputSigarusText, [{
	hook: 'input',
	callback: function (comp, val) {
		return val + ' prueba test'
	}
}], {});
*/

const inputs = {
	textarea: InputSigarusTextarea,
	checkbox: InputSigarusCheckbox,
	checkboxList: InputSigarusCheckboxList,
	switch: InputSigarusSwitch,
	file: InputSigarusFile,
	filedrag: InputSigarusFileDrag,
	text: InputSigarusText,
	timepicker: InputSigarusTimePicker,
	datepicker: InputSigarusDatePicker,
	datetimepicker: InputSigarusDateTimePicker,
	hidden: InputSigarusHidden,
	...numberVariations,
	...selectVariations,
	editor: InputSigarusEditor,
	link: InputSigarusLink,
	password: InputSigarusPassword
}

export default Object.keys(inputs).reduce((o, k) => {

	const iName = `l-${k}`

	o[iName] = inputs[k]

	if (!o[iName].methods) o[iName].methods = {}

	return o

}, {})
